
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"mini-fridge",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"bg",attrs:{"stroke":"#414142","stroke-width":"2","fill":"#FFF","d":"M1 1h58v58H1z"}}),_c('g',{staticClass:"fridge icon-img",attrs:{"fill":"#3F3F40"}},[_c('path',{attrs:{"d":"M41.106 24.927H19.62V11.906c0-.558.452-1.01 1.01-1.01h19.448c.561 0 1.019.449 1.028 1.01v13.021zm0 24.292a1.06 1.06 0 01-1.072 1.053H20.64c-.561 0-1.02-.459-1.02-1.02V26.857h21.486v22.362zm-.971-40.165H20.669a2.9 2.9 0 00-2.891 2.891V49.23c0 1.6 1.301 2.892 2.891 2.884h19.466a2.9 2.9 0 002.9-2.884V11.938c0-1.592-1.3-2.884-2.9-2.884z"}}),_c('path',{attrs:{"d":"M37.422 17.548v3.62c0 .48.354.902.833.948a.924.924 0 001.01-.917v-3.683a.923.923 0 00-1.01-.916c-.479.045-.833.468-.833.948M39.264 34.256v-4.54c0-.48-.354-.903-.833-.948a.923.923 0 00-1.009.916v4.604c0 .535.464.968 1.01.917.478-.046.832-.469.832-.949"}})])])])
          )
        }
      }
    